export default __webpack_public_path__ + "static/media/closet5-before2-768w.37ba88c0.webp";